import { Application } from "../application/application";
import { REQUEST_ATTRIB_DOMAIN } from "../panel/cabinets";
import { Dialog, DialogDefinition } from "../panel/dialog";
import { ContainerPanel } from "../panel/panel";
import  { ReportsDialog as SvelteReportsDialog }   from '@mapp/r-mapp-lib';

export const createExportDialogDefinition = (): DialogDefinition => {
	return {
		build: (panel: ContainerPanel, dialogId: string, application: Application): Dialog => {
			return new ReportsDialog(panel, dialogId, application);
		},
		url: '/' + REQUEST_ATTRIB_DOMAIN + '/system/template/dialog-export'
	}
}

interface ReportCategoryDefinition {
	icon: string,
	label: string,
	name: string,
	permission: string,
	category: string,
	group: string,
	options: {
		url: string
	}
}

export class ReportsDialog extends Dialog {

	private categoryDefinitions: ReportCategoryDefinition[];


	constructor(panel: ContainerPanel, containerId: string, app: Application) {
		super(panel, containerId, app);
	}

	/**
 * This one gets called once the skeleton markup is available
 */
	protected finishDialogBuild(): Promise<Dialog> {

		const containerElem = this.getContainerNode();

		//setup categories
		const categorySectionNode = <HTMLElement>this.getContainerNode().querySelector('div.tlmd-generic-container.categories');
		if (categorySectionNode) {
			this.categoryDefinitions = JSON.parse(categorySectionNode.dataset.categories);
			//console.log('categories=%o', this.categoryDefinitions);
		}
		let timeRange = this.getApplication().getMainTimeline().getTimeRange();
		let start = timeRange.visible.start;
		let end = timeRange.visible.end;
		//console.log('start=', start, ' end=', end);
		
		const svelteContainer = <HTMLElement>this.getContainerNode().querySelector('div.svelte-exports-dialog');
		//console.log(svelteContainer);
		new SvelteReportsDialog({
    		target: svelteContainer,
    		props: {
    			categories: this.categoryDefinitions,
    			start,
    			end,
				usage: "export"
    		}
    	});
		

		return new Promise<Dialog>((resolve, _reject) => {
			resolve(this);
		});

	}

	public release(): Dialog {
		return super.release();
	}


}
